import React from 'react'
import { Routes, Route } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import Header from './components/Header'
import Footer from './components/Footer'
import Forside from './pages/Forside'
import Udlejning from './pages/Udlejning'
import VaerktojsUdlejning from './pages/VaerktojsUdlejning'
import Kontakt from './pages/Kontakt'

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-neutral-950 text-white font-sans antialiased selection:bg-amber-500 selection:text-neutral-950">
      {/* Scroll restoration */}
      <ScrollToTop />

      {/* Sticky Header */}
      <Header />

      {/* Main Content */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Forside />} />
          <Route path="/udlejning" element={<Udlejning />} />
          <Route path="/vaerktojsudlejning" element={<VaerktojsUdlejning />} />
          <Route path="/kontakt" element={<Kontakt />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  )
}

export default App
